import { TextField, TextFieldProps } from '@mui/material'
import React, { forwardRef, ForwardRefRenderFunction } from 'react'
import { Controller, Control } from 'react-hook-form'

const currencyFormatter = (value: string): string => {
  // Remove everything that's not a digit
  const cleanValue = value.replace(/\D/g, '');

  // Convert it to a number and format as BRL
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(parseFloat(cleanValue) / 100);

  return formattedValue;
}

interface InputCurrencyProps extends Omit<TextFieldProps, 'name'> {
  name: string;
  control: Control<any>;
  defaultValue?: string;
}

const BaseInput: ForwardRefRenderFunction<HTMLInputElement, InputCurrencyProps> = (
  {
    sx = {},
    name,
    control,
    defaultValue = '',
    ...rest
  },
  ref
) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => {
        const formattedValue = currencyFormatter(field.value || '0');

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const inputValue = event.target.value;
          const formattedValue = currencyFormatter(inputValue);

          field.onChange(formattedValue);
        }

        return (
          <TextField
            ref={ref}
            value={formattedValue}
            onChange={handleChange}
            sx={{
              width: '100%',
              ...sx,
            }}
            {...rest}
          />
        );
      }}
    />
  );
}

export const InputCurrency = forwardRef(BaseInput);
